import { configureStore } from '@reduxjs/toolkit';
import {
  createStateSyncMiddleware,
  initStateWithPrevTab,
} from 'redux-state-sync';
import rootReducer from './reducers'; // Your combined reducers

const reduxStateSyncConfig = {
  sync: true, // Enable state synchronization
  channel: 'atlantis_preview', // Specify a unique channel name
  broadcastChannelOption: { type: 'localstorage' }, // Use the Broadcast Channel API
};

const middleware = [createStateSyncMiddleware(reduxStateSyncConfig)];

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
});

initStateWithPrevTab(store);
export default store;
